import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { ProductionListConf } from './production-list-conf'
import { ProductionListConfService } from './production-list-conf.service'

@Injectable({
  providedIn: 'root',
})
export class ProdListConfResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private prodListConfService = inject(ProductionListConfService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public resolve(route: ActivatedRouteSnapshot): Observable<ProductionListConf> {
    const id = route.paramMap.get('id')
    return this.prodListConfService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('messages.loading_failed', err)
        return EMPTY
      })
    )
  }
}
